// deps
import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
    body {
        font-family: "Gilroy", Arial, sans-serif !important;
    }
    h4 {
        margin-top: 0;
    }
`;
